import { Wrapper, Text } from './Styled'

interface CurrencyProps {
  product_coin?: string | number
}

export default function Currency({ product_coin }: CurrencyProps) {
  return (
    <Wrapper>
      <Text>{product_coin}$</Text>
    </Wrapper>
  )
}
